/**
 * Shared mutable map state used across modules.
 */

/** @type {google.maps.Map|null} */
export let map = null;

/** @type {google.maps.LatLngBounds|null} */
export let mapBounds = null;

/** @type {Object.<string, google.maps.marker.AdvancedMarkerElement[]>} */
export const theMarkers = {};

/** @type {google.maps.marker.AdvancedMarkerElement|null} */
export let userLocationMarker = null;

/** @type {google.maps.Circle|null} */
export let radiusCircle = null;

/** @type {typeof google.maps.marker.AdvancedMarkerElement|null} */
export let AdvancedMarkerElementClass = null;

/** @type {typeof google.maps.marker.PinElement|null} */
export let PinElementClass = null;

/** @type {string} Active visit-status filter slug, or "all". */
export let activeVisitStatus = 'all';

/**
 * Sets the active visit-status filter used by marker visibility.
 *
 * @param {string} status Visit-status slug or "all".
 * @return {void}
 */
export function setActiveVisitStatus( status ) {
	activeVisitStatus = status;
}

/**
 * Sets the active Google Map instance.
 *
 * @param {google.maps.Map} nextMap Map instance.
 * @return {void}
 */
export function setMap( nextMap ) {
	map = nextMap;
}

/**
 * Sets the LatLngBounds covering voter markers.
 *
 * @param {google.maps.LatLngBounds} bounds Marker bounds.
 * @return {void}
 */
export function setMapBounds( bounds ) {
	mapBounds = bounds;
}

/**
 * Sets the Advanced Marker / Pin constructors from importLibrary.
 *
 * @param {typeof google.maps.marker.AdvancedMarkerElement} AdvancedMarkerElement Marker class.
 * @param {typeof google.maps.marker.PinElement} PinElement Pin class.
 * @return {void}
 */
export function setMarkerClasses( AdvancedMarkerElement, PinElement ) {
	AdvancedMarkerElementClass = AdvancedMarkerElement;
	PinElementClass = PinElement;
}

/**
 * Sets or clears the user-location marker.
 *
 * @param {google.maps.marker.AdvancedMarkerElement|null} marker User marker.
 * @return {void}
 */
export function setUserLocationMarker( marker ) {
	userLocationMarker = marker;
}

/**
 * Sets or clears the radius circle overlay.
 *
 * @param {google.maps.Circle|null} circle Radius circle.
 * @return {void}
 */
export function setRadiusCircle( circle ) {
	radiusCircle = circle;
}
